import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SnackBarWrapperService } from '../services/snack-bar-wrapper.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private oidcSecurityService: OidcSecurityService,
    private _snackBar: SnackBarWrapperService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
          //Obsługa konkretnych statusów
        if (err.status === 401) {
          this.oidcSecurityService.forceRefreshSession();
          return throwError(() => err); // Zwracamy throwError po odświeżeniu sesji
        } else if (err.status === 403) {
          this._snackBar.openMessage('Brak uprawnień', 'error');
           return throwError(() => err); // Zwracamy throwError po obsłużeniu błędu
        } else if (err.status >= 400) {
          return this.handleError(err)
        }

        // Wszystkie pozostałe błędy wracają bez zmiany (nie powinny się w sumie zdarzyć).
        return throwError(err);
      })
    );
  }

    //Metoda obsługująca błędy z wywołania API.
    private handleError(err: HttpErrorResponse): Observable<never> {
        
        if (err.error instanceof Blob && err.error.type === 'application/json') {
            return this.handleBlobError(err);
        } else {
            this.showErrors(err.error);
            return throwError(err)
        }  
    }

    // Metoda odczytująca blob z jsonem z API.
    private handleBlobError(err: HttpErrorResponse) : Observable<never> {
        return new Observable<never>(observer => {
            const reader = new FileReader();
            reader.onload = (e: ProgressEvent<FileReader>) => {
                try{
                    const response: any = JSON.parse(e.target.result as string) as any;
                    this.showErrors(response);
                    observer.error(err)
                } catch (e) {
                   observer.error(err);
                }
            };
            reader.onerror = (e) => {
                observer.error(err);
            }
            reader.readAsText(err.error);
        })

    }

  //Metoda do wyciągania wiadomości z odpowiedzi API i wyświetlania w snack barze.
  private showErrors(data: any) {
    let errors = '';
    if (data) {
      const errorSource = data.errors || data.Errors; // Sprawdź obie nazwy
      if (errorSource) {
          if (typeof errorSource === 'object') {
              for (const [key, value] of Object.entries(errorSource)) {
                  errors += `${key}: ${value}\n`;
              }
          } else if (Array.isArray(errorSource)) {
             errors = errorSource.join('<br />');
          } else if (typeof errorSource === 'string'){
            errors = errorSource
          }

      }
    }
    if(errors)
      this._snackBar.openMessage(errors, 'error');
    else
      this._snackBar.openMessage("Wystąpił błąd", 'error');
  }
}